/* eslint-disable react/prop-types */
// src/context/UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { auth } from "../firebaseConfig"; // Import your Firebase config

// Create a context for the user
export const UserContext = createContext(null);

// Create a provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Subscribe to the auth state and update the user context
    const unsubscribe = auth.onAuthStateChanged(() => {
      setUser(auth.currentUser); // Set user to current user or null if not logged in
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // or some loading spinner
  }

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
